export function handleError(error) {
  console.log(error.response.status)
}
